export enum ExportControlStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  NotAuthorized = 'NotAuthorized',
}
